import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "../store";

export type StreamingSocketState = {
  documentTitle: string;

  chatList: MessageInList[];
  chatListOffset: number;

  subscribedUserId: number;
  recipient: Recipient | null;

  chatRoom: ChatRoom;

  messages: SocketRersponseValue[];
  streamingMessagesQueue: string;
  messagesOffset: number;

};

const initialState: StreamingSocketState = {
  documentTitle: "",

  chatList: [],
  chatListOffset: 0,

  subscribedUserId: 904,
  recipient: null,

  chatRoom: {
    allowChatRoom: false,
    loading: true,
    error: false,
    status: "ready",
    sendingMessage: false,
    agentThinking: false,
    hasMoreMessages: true,
  },

  messages: [],
  streamingMessagesQueue: "",
  messagesOffset: 0,

};

const streamingSocketSlice = createSlice({
  name: "streamingSocket",
  initialState,
  reducers: {
    setDocumentTitle(state, action: PayloadAction<string>) {
      state.documentTitle = action.payload;
    },

    setChatList(state, action: PayloadAction<MessageInList[]>) {
      state.chatList = action.payload;
    },
    setRecipient(state, action: PayloadAction<Recipient | null>) {
      state.recipient = action.payload;
    },
    setChatRoom(state, action: PayloadAction<Partial<ChatRoom>>) {
      state.chatRoom = { ...state.chatRoom, ...action.payload };
    },
    setChatRoomLoading(state, action: PayloadAction<boolean>) {
      state.chatRoom.loading = action.payload;
    },
    setChatRoomError(state, action: PayloadAction<boolean>) {
      state.chatRoom.error = action.payload;
    },
    setChatRoomStatus(state, action: PayloadAction<ChatRoom["status"]>) {
      state.chatRoom.status = action.payload;
    },
    setChatListOffsetNumber(state, action: PayloadAction<number>) {
      state.chatListOffset = action.payload;
    },
    incrementChatListOffsetNumber(state) {
      state.chatListOffset += 10;
    },
    setSubscribedUserId(state, action: PayloadAction<number>) {
      state.subscribedUserId = action.payload;
    },
    pushUserToList(state, action: PayloadAction<MessageInList>) {
      state.chatList.push(action.payload);
    },
    setMessagesList(state, action: PayloadAction<SocketRersponseValue[]>) {
      state.messages = action.payload;
    },
    updateMessageContent(state, action: PayloadAction<{ content: string; index: number }>) {
      const { content, index } = action.payload;

      if (state.messages[index]) {
        state.messages[index].message.message = content;
      }
    },
    setStreamingMessagesQueue(state, action: PayloadAction<string>) {
      state.streamingMessagesQueue = action.payload;
    },
    setMessagesOffsetNumber(state, action: PayloadAction<number>) {
      state.messagesOffset = action.payload;
    },
    setMessageHasMore(state, action: PayloadAction<boolean>) {
      state.chatRoom.hasMoreMessages = action.payload;
    },
    incrementMessagesOffsetNumberByOne(state) {
      state.messagesOffset += 1;
    },
    incrementMessagesOffsetNumberByTen(state) {
      state.messagesOffset += 10;
    },

    // equivalents of “unset…” actions
    resetChatList(state) {
      state.chatList = [];
    },
    resetChatListOffset(state) {
      state.chatListOffset = 0;
    },
    resetMessagesOffset(state) {
      state.messagesOffset = 0;
    },
    resetMessageStates(state) {
      state.messages = [];
      state.subscribedUserId = 0;
      state.messagesOffset = 0;
      state.streamingMessagesQueue = "";
    },
  },
});

export const streamingSocketActions = streamingSocketSlice.actions;
export default streamingSocketSlice.reducer;

// selectors (Vuex getters)`
export const streamingSocketSelectors = {
  documentTitle: (s: RootState) => s.streamingSocket.documentTitle,
  chatList: (s: RootState) => s.streamingSocket.chatList,
  chatListOffsetNumber: (s: RootState) => s.streamingSocket.chatListOffset,
  subscribedUserId: (s: RootState) => s.streamingSocket.subscribedUserId,
  chatRoom: (s: RootState) => s.streamingSocket.chatRoom,
  // messageUnreadNumber: (s: RootState) => s.streamingSocket.messageUnread,
  messagesList: (s: RootState) => s.streamingSocket.messages,
  messagesOffsetNumber: (s: RootState) => s.streamingSocket.messagesOffset,
};